import Promise from 'bluebird';
import requestPermissionTemplate from './request-permission-template.pug';

export function getRequestPermission({ i18n, deliveryStatus }) {
  return Promise.resolve(requestPermissionTemplate({
    i18n,
    deliveryStatus,
    showRequestPermissionBtn: false,
  }));
}
